import * as React from "react"
export const CheckIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    className="stroke-fg-1"
    strokeWidth="2"
    {...props}>
    <path d="M8.33366 2.5L3.75033 7.08333L1.66699 5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
